/* eslint-disable max-len */
import { PageTitle, Button } from '@components';
import { useNavigate } from 'react-router-dom';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPaymentMethod } from '@store';
import { useReviewData } from '@hooks';
import { ErrorCode } from '@/constants';
import Method from './Method';
import ModalForm from './components/ModalForm';
import { TITLE_TEXT, getMethods } from './const';

import classes from './index.module.css';
import './index.css';

export const Payment = () => {
  const [open, setOpen] = useState(false);
  const [payment, setPayment] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const disPatch = useDispatch();
  const { supportedPaymentMethod } = useSelector((state) => state.claim);
  const { getReviewData } = useReviewData();

  const goToNextPage = async (info) => {
    setLoading(true);

    try {
      const isSuccess = await getReviewData({ payment, ...info });
      if (isSuccess) {
        navigate('../review');
      } else {
        navigate('../error', { state: { code: ErrorCode.Wrong } });
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };
  const handleMethodClick = (payment) => {
    setPayment(payment);
    disPatch(setPaymentMethod({ label: payment.label, value: payment.value }));
    if (!payment.hasModal) {
      goToNextPage({
        payment, directDepositPayAccount: {}, paypalPayAccount: {}, venmoPayAccount: {},
      });
      return;
    }
    setOpen(true);
  };

  const paymentMethods = getMethods(supportedPaymentMethod);
  return (
    <div className={classes.wrapper}>
      <PageTitle title={TITLE_TEXT} />
      <div className={classes.content}>
        {paymentMethods.map((item) => <Method item={item} key={item.value} handleMethodClick={() => handleMethodClick(item)} />)}
      </div>
      <Button
        variant="outlined"
        startIcon={<ArrowBackRoundedIcon />}
        style={{
          border: '1px solid #BABFC3',
          borderRadius: '2px',
          color: '#202223',
          padding: '8px 16px',
          marginTop: '20px',
          boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.05)',
        }}
        sx={{
          backgroundColor: '#FFFFFF',
          '&:hover': {
            backgroundColor: '#F6F6F7',
          },
        }}
        onClick={() => {
          navigate(-1);
        }}
      >
        Back
      </Button>
      <ModalForm open={open} payment={payment} setOpen={setOpen} goToNextPage={goToNextPage} loading={loading} />
    </div>
  );
};
